import React, { Component } from 'react'
import { Table, Spin } from 'antd'

class ContactsAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'Company',
        dataIndex: 'company'
      },
      {
        title: 'First Name',
        dataIndex: 'first_name'
      },
      {
        title: 'Last Name',
        dataIndex: 'last_name'
      },
      {
        title: 'Title',
        dataIndex: 'title'
      },
      {
        title: 'Email',
        dataIndex: 'primary_email'
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_number'
      },
      {
        title: 'Mobile Number',
        dataIndex: 'mobile_number'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { contactsAddedData } = this.props

    const data = contactsAddedData.map((user, index) => {
      const returnObj = Object.assign({ key: `${user.id}${index}` }, user)
      delete returnObj.id
      return returnObj
    })
    return data
  }

  render() {
    const { loadingContactsAdded, contactsAddedData } = this.props
    return (
      <div>
        {loadingContactsAdded && !contactsAddedData && <Spin />}
        {!loadingContactsAdded &&
          contactsAddedData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default ContactsAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/ContactsAdded.js